import {
  Row,
  Column,
  CancelButton,
  Form,
  intlShape,
  SubmitButton,
  TextInput,
  withIntl,
} from "lcm-iot-commons";
import { Formik } from "formik";

const allow6Numbers = /^\d{6}$/;

type Props = {
  intl: intlShape;
  onSubmit: $TSFixMeFunction;
  onCancel: $TSFixMeFunction;
};

export function MultiFactorAuthenticationRecoveryCodesForm({
  onSubmit,
  onCancel,
  intl,
}: Props) {
  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (!values.otpCodeToken) {
      (errors as $TSFixMe).otpCodeToken = intl.formatMessage({
        id: "mfa.code_mandatory",
      });
    } else if (!allow6Numbers.test(values.otpCodeToken)) {
      (errors as $TSFixMe).otpCodeToken = intl.formatMessage({
        id: "mfa.code_format",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form {...formProps}>
        <Row>
          <Column md={12}>
            <TextInput
              {...formProps}
              id="mfa-code"
              name="otpCodeToken"
              otpCodeToken
              label={intl.formatMessage({ id: "mfa.code" })}
              placeholder={intl.formatMessage({ id: "mfa.code_placeholder" })}
              required
            />
          </Column>
        </Row>
        <Row>
          <Column md={12}>
            <div className="modal-btn-group">
              <SubmitButton
                id="mfa-change-submit"
                text={intl.formatMessage({ id: "button.confirm" })}
                fetching={isSubmitting}
                disabled={!formProps.dirty}
              />
              <CancelButton
                id="mfa-change-cancel"
                handleOnClick={onCancel}
                // @ts-expect-error TS(2322) FIXME: Type '{ id: string; handleOnClick: $TSFixMeFunctio... Remove this comment to see the full error message
                disabled={isSubmitting}
                intl={intl}
              />
            </div>
          </Column>
        </Row>
      </Form>
    );
  };

  return (
    <Formik
      id="change-mfa-form"
      onSubmit={onSubmit}
      validate={validateForm}
      initialValues={{}}
    >
      {renderForm}
    </Formik>
  );
}

export default withIntl(MultiFactorAuthenticationRecoveryCodesForm);
